$( window ).on( 'load', () => {
	console.log( 'Loaded!');
} );

const navButton = document.querySelector('.nav__button');
const navMenu = document.querySelector('.nav__menu-box');
const menuIcon = document.querySelector('.nav__icon');

navButton.addEventListener('click', ()=> {
	navMenu.classList.toggle('nav__menu-box--act');
	menuIcon.classList.toggle('nav__icon--act');
	
});